import { render, staticRenderFns } from "./TestTwo.vue?vue&type=template&id=5a276d54&scoped=true&"
import script from "./TestTwo.vue?vue&type=script&lang=js&"
export * from "./TestTwo.vue?vue&type=script&lang=js&"
import style0 from "./TestTwo.vue?vue&type=style&index=0&id=5a276d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a276d54",
  null
  
)

export default component.exports